module.exports = __webpack_public_path__ + "static/img/equipment1.01448271.png";